import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { State } from "store";
import { THEME_DEFAULT, THEME_LIGHT } from "store/userMeta";
import lottie from "lottie-web";
import "./Animation.scss";

const Animation: React.FC<{
  animation: {
    light: any;
    dark: any;
  };
  loop?: boolean;
  title?: string;
  className?: string;
  titleStyle?: string;
}> = ({ animation, loop = true, title, className, titleStyle }) => {
  const theme = useSelector((state: State) => {
    return state.userMeta?.theme ?? THEME_DEFAULT;
  });
  const animationContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    lottie.destroy();
    if (animationContainer.current) {
      lottie.loadAnimation({
        container: animationContainer.current,
        animationData: THEME_LIGHT === theme ? animation.light : animation.dark,
        renderer: "svg",
        loop
      });
    }
  }, [theme, animation, loop]);

  const titleStyleClasses = `animation-title ${
    titleStyle && titleStyle.length > 0 ? titleStyle : "mb-15"
  }`;

  return (
    <>
      <div
        className={`animation-container ${className}`}
        ref={animationContainer}
        data-testid="animation-container"
      ></div>
      {title && <h4 className={titleStyleClasses}>{title}</h4>}
    </>
  );
};

export default Animation;
